import { Vector, Rectangle, Geometry, Point } from "../../drawing";
import { AbstractDrawableItem } from "./AbstractDrawableItem";

export abstract class AbstractVectorItem extends AbstractDrawableItem {
  constructor(typeKey: string) {
    super(typeKey);
  }

  get vector(): Vector {
    return this._vector;
  }

  set vector(value: Vector) {
    this._vector = value;
    this.geometry = new Geometry(Rectangle.from(value));
  }

  private _vector: Vector = new Vector();

  protected applyMembers(clone: AbstractVectorItem): void {
    super.applyMembers(clone);
    clone.vector = this.cloneValue(this.vector);
  }

  move(difference: Point): void {
    if (this.isPositionFixed) { return; }
    this.vector = this.vector.move(difference);
  }
}
